import { Component } from '@angular/core';

@Component({
  selector: 'expired-invitation',
  templateUrl: './expired-invitation.component.html',
  styleUrls: ['./expired-invitation.component.scss'],
})
export class ExpiredInvitationComponent {}
